import { SkypeIcon } from './SkypeIcon';

/**
 * author: Contributors
 * id 07E9D89D-2D58-40C6-9D41-49722CFC0DAE
 * name skype
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skype.svg
 * tags
 * - Brand / Logo 
 */
export const MicrosoftSkypeIcon = SkypeIcon;
export default MicrosoftSkypeIcon